module.exports = __webpack_public_path__ + "img/aw-mobile-hover.8a74ab35.png";